module.exports = __webpack_public_path__ + "static/media/Living2.26f8eadd.webp";